import React, { useContext, memo } from 'react';
import { context } from '../../../context';
import { RatingStars } from '../RatingStars';
import { Margin, CommentsMsg } from '../../atoms';
import { RatingAverageContainer, RatingAverageStyle } from './Styled';

const Average = () => {
  const { data } = useContext(context);
  const ratingAverage = data?.rating?.calculated;
  const average = ratingAverage?.toString()?.indexOf('.') > -1 ? ratingAverage : `${ratingAverage}.0`;
  const { comments } = data;
  const total = data?.rating?.count;

  return (
    <RatingAverageContainer>
      <RatingAverageStyle>{average}</RatingAverageStyle>
      <RatingStars size={26} rating={average} />
      <Margin top={5} bottom={5} left={10} />
      <CommentsMsg numberComments={comments} numberReviews={total} onHeader={true} />
    </RatingAverageContainer>
  );
};

const RatingAverage = memo(Average);

export default RatingAverage;
export { RatingAverage };
